import { Component } from '@angular/core';
import { SelfserviceService } from './selfservice.service';
import { SelfserviceHeaderComponent } from './components/selfservice-header/selfservice-header.component';
import { SelfserviceLanguageSelectorComponent } from './components/selfservice-language-selector/selfservice-language-selector.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-selfservice-main',
    templateUrl: './selfservice-main.component.html',
    styleUrls: ['./selfservice-main.component.scss'],
    imports: [
        SelfserviceHeaderComponent,
        SelfserviceLanguageSelectorComponent,
        RouterOutlet,
    ],
})
export class SelfserviceMainComponent {
    constructor(private selfserviceService: SelfserviceService) {}
}
